import styled from "styled-components";

interface IContainerProps {
  criare?: boolean;
  italinea?: boolean;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 90%;
  margin-bottom: 0.3rem;
  @media (max-width: 1200px) {
    width: 100%;
  }

  .column1 img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
  }

  .column2 {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding-left: 2.2rem;
    width: 100%;
    @media (max-width: 1200px) {
      text-align: left;
    }
  }

  .name {
    font-family: "Galano";
    line-height: 2.4rem;
    font-size: 2rem;
    font-weight: ${(props) => (props.criare ? 800 : 600)};
    font-style: normal;
    color: ${(props) => (props.criare ? "black" : "#565656")};
    margin: 1rem 0;
    @media (max-width: 1200px) {
      font-size: 1.2rem;
    }
  }

  .address {
    font-family: "Galano";
    line-height: 2.2rem;
    font-size: 1.7rem;
    font-weight: ${(props) => (props.criare ? 400 : 300)};
    font-style: normal;
    color: ${(props) => (props.criare ? "black" : "#bdbdbd")};
    @media (max-width: 1200px) {
      font-size: 1.2rem;
    }
  }

  .phone {
    font-family: "Galano";
    line-height: 1.9rem;
    font-size: 1.7rem;
    font-weight: ${(props) => (props.criare ? 800 : 600)};
    font-style: normal;
    color: ${(props) => (props.criare ? "black" : "#565656")};
    @media (max-width: 1200px) {
      font-size: 1.2rem;
    }
  }

  a {
    margin: 2rem 0;
    font-family: "Galano";
    text-decoration: none;
    @media (max-width: 1200px) {
      margin: 1rem 0;
    }
  }

  .btn-whatsapp {
    font-family: "Galano";
    width: 100%;
    max-width: 307px;
    height: 60px;
    background: #1c7202;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 4px;
    font-size: 17px;
    font-weight: 300;
    @media (max-width: 1200px) {
      font-size: 1.2rem;
      height: 36px;
      padding: 15px;
    }
    img {
      height: 20px;
      margin-right: 10px;
      @media (max-width: 1200px) {
        max-height: 14px;
      }
    }
  }
`;
